import React, { createContext, useState, useEffect, useCallback } from 'react';
import { STORAGE_KEY } from '../services/api';

// Decodifica el payload del JWT y verifica que no esté expirado.
// No valida la firma (eso lo hace el backend); solo evita cargar tokens claramente inútiles.
const isTokenValid = (auth) => {
    if (!auth?.token) return false;
    try {
        const payload = JSON.parse(atob(auth.token.split('.')[1]));
        return typeof payload.exp === 'number' && payload.exp * 1000 > Date.now();
    } catch {
        return false;
    }
};

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(() => {
        try {
            const storedAuth = JSON.parse(localStorage.getItem(STORAGE_KEY));
            return isTokenValid(storedAuth) ? storedAuth : null;
        } catch {
            return null;
        }
    });

    useEffect(() => {
        if (auth) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(auth));
        } else {
            localStorage.removeItem(STORAGE_KEY);
        }
    }, [auth]);

    const logout = useCallback(() => {
        setAuth(null);
    }, []);

    // Escucha el evento emitido por el interceptor de api.js cuando el backend responde 401
    useEffect(() => {
        window.addEventListener('auth:unauthorized', logout);
        return () => window.removeEventListener('auth:unauthorized', logout);
    }, [logout]);

    return (
        <AuthContext.Provider value={{ auth, setAuth, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
